import { useConfig } from '@seek/libs-shared';

export const useIsSalariesPageFeatureOn = () => {
  const config = useConfig();
  const { brand } = config;
  return brand === 'seek' || brand === 'jobstreet';
};
